import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { BookingContentService } from 'src/app/services/bookingContentService/booking-content.service';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-travel-comfort',
    templateUrl: './travel-comfort.component.html',
    styleUrls: ['./travel-comfort.component.scss'],
    imports: [MatIcon]
})
export class TravelComfortComponent implements OnInit, OnDestroy {
  private destroy$ =  new Subject<void>();
  content:any;
  constructor(private contentService:BookingContentService){

  }
  ngOnInit(){
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.content = res;
    });
  }
  ngOnDestroy(){
    this.destroy$.next();
    this.destroy$.complete();
  }
}
